<template>
<div class="pr-3 pl-3 inner-admin-container">
  <b-tabs pills card>
    <b-tab v-for='(key, index) in keys' no-body :title="key" :key="index +'-tab'">
      <b-form v-on:submit.prevent="save" class='p-2'>
        <b-row v-for='(setting, i) in configMap[key]' :key="configMap[key]['id'] + '-' + i +'row'">
          <b-col>
            <b-form-group :id="configMap[key]['id'] + '-' + i +'-group'" horizontal label-size="sm" :label="setting.text+':'" :label-for="configMap[key]['id'] + '-' + i + '-input'">
              <b-form-input :id="configMap[key]['id'] + '-' + i +'-input'" size="sm" type="text" v-model="setting.value" v-on:keyup.native="commitValue(setting)" placeholder="None">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div id='general-initial-save' v-if="state === 'DEFAULT'">
          <b-button class="btn-xs" variant="primary" v-on:click.prevent="check">Save</b-button>
        </div>
        <div id='general-initial-save-check' v-if="state === 'CHECK'">
          <b-alert class='user-reminder' variant="warning" show>Are you sure you wish to make these changes to the general config?</b-alert>
          <b-button class="btn-xs" variant="primary" v-on:click.prevent="state = 'DEFAULT'">No</b-button>
          <b-button class="btn-xs" variant="primary" v-on:click.prevent="save">Yes</b-button>
        </div>
      </b-form>
    </b-tab>
  </b-tabs>
</div>
</template>
<script>
export default {
  data() {
    return {
      configMap: {},
      keys: [],
      package: {},
      state: 'DEFAULT'
    }
  },
  mounted() {
    this.$http.get('/api/admin-board/general-settings').then(res => {
      this.createConfigMap(res.body)
    }, r => {
      this.$notify({
        title: 'ERROR',
        text: 'Could not get general settings',
        type: 'error'
      })
    })
  },
  methods: {
    createConfigMap(data) {
      data.forEach(d => {
        let m = {
          id: d.id,
          text: d.param,
          value: d.value
        }
        if (!this.configMap[d.usedfor]) {
          this.configMap[d.usedfor] = []
          this.keys.push(d.usedfor)
        }
        this.configMap[d.usedfor].push(m)
      })
    },
    commitValue(setting) {
      this.package[setting.id] = setting.value
    },
    check() {
      if (Object.keys(this.package).length) {
        this.state = 'CHECK'
      } else {
        this.$notify({
          title: 'Warning',
          text: 'Nothing to save, update a field',
          type: 'warning'
        })
      }
    },
    save() {
      this.state = 'DEFAULT'
      this.$http.post('/api/admin-board/update-general-settings/', {
        data: this.package
      }).then(res => {
        this.$notify({
          title: 'SUCCESS',
          text: 'General settings updated',
          type: 'success'
        })
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not update general settings',
          type: 'error'
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/admin/GeneralConfig.vue